import { from as from$ } from 'rxjs';

import CoverageService from '../../../services/coverage.service';
import { parseInfoBox } from '../../../parsers/infobox.parser';
import { requestId } from './request.helper';
import { isPatientPresent } from './patient.helper';

export const updateCoverages = store => {
  const shouldUpdateBillToFacility = store.value.infobox.billedToFacilityChange;
  const payload = {
    coverages: parseInfoBox(store.value).coverages,
    ...(shouldUpdateBillToFacility ? { isBilledToFacility: store.value.infobox.isBilledToFacility } : {}),
  };
  return from$(CoverageService.updateCoverages(requestId(store), payload));
};

export const isCoverageDataValid = state =>
  !state.formFlow.submitInProgress && state.requests.request.id && isPatientPresent(state);

export const checkPayerRules = store => from$(CoverageService.checkPayerRules(requestId(store)));

export const getCoverages = store => from$(CoverageService.getCoverages(requestId(store)));
